import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import {
  Company,
  CompanyType,
  PaginatedResponseWithTotal,
} from "@/common/types";
import { generateParamsFromObj } from "@/common/utils";

const getCompanyByName = async (searchQ: string, companyType: string) => {
  const params = generateParamsFromObj({
    filters: { companyType: companyType },
  });
  params.append("searchFields", "companyName");
  params.append("searchQ", searchQ);
  params.append("skip", "0");
  params.append("take", "10");

  return await axiosInstance
    .get("company/all", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetCompanyByName = ({
  searchQ,
  companyType,
}: {
  searchQ: string;
  companyType: CompanyType;
}) => {
  return useQuery<PaginatedResponseWithTotal<Company>>({
    queryKey: ["company", searchQ, companyType],
    queryFn: () => getCompanyByName(searchQ, companyType),
    enabled: !!searchQ,
  });
};
export default useGetCompanyByName;
